var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcHome = function SvgIcHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 11.357a1 1 0 0 1 .295-.709l8-7.948a1 1 0 0 1 1.41 0l8 7.948a1 1 0 0 1 .295.71V20a1 1 0 0 1-1 1h-4.187a1 1 0 0 1-1-1v-3.588a1 1 0 0 0-1-1h-3.626a1 1 0 0 0-1 1V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"
  })));
};
export default SvgIcHome;